import React, { Component } from 'react';
import './App.css';
import Login from './login.js';
import TwoFactor from './twoFactor.js';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { FaBuilding, FaGlobe, FaUndo, FaIdBadge, FaSignOutAlt, FaTools, FaQuestion } from 'react-icons/fa';


var Views = {}
var comps = require.context('./Views', false, /.*/)
comps.keys().forEach((item) => {
	Views[item.replace('./', '').split('.')[0]] = {}
	Views[item.replace('./', '').split('.')[0]].comp = comps(item)[item.replace('./', '').split('.')[0]]
	Views[item.replace('./', '').split('.')[0]].icon = comps(item).icon
})

var img = {}
var imgs = require.context('./img', false, /.*/)
imgs.keys().forEach((item) => {
	img[item.replace('./', '').split('.')[0]] = imgs(item)
})

class App extends Component {
	static propTypes = { cookies: instanceOf(Cookies).isRequired }
	constructor(props) {
		super(props);
		this.state = {
			domains: [],
			loggedIn: false,
			user: '',
			domain: '',
			org: '',
			progress: false,
			dynamicParams: {},
			RealTimeStats: {},
			firstName: '',
			lastName: '',
			adjustingPIN: false,
			adjustPIN: '',
			adjustPINError: '',
			availableViews: [],
			views: [],
			memo: false,
			help: false,
			loginError: '',
			activeView: "RealTimeStats",
			dropdownDomainVisible: false,
			dropdownEmailVisible: false,
		};
	}


	adjustPIN = (e) => {
		this.setState({ adjustingPIN: true, adjustPIN: '', adjustPINError: '' })
	}
	adjustPINChange = (e) => {
		this.setState({ adjustPIN: e.target.value, adjustPINError: '' });
	}
	help = (e) => {
		console.log('help')
		this.setState({ help: true })
	}

	confirmAdjustPIN = () => {
		if (this.state.adjustPIN.length < 1) { this.setState({ adjustPINError: 'Please Enter a New Password' }) };
		this.setState({ loading: true });
		this.ws.send(JSON.stringify({ route: 'adjustPIN', user: this.state.user, adjustPIN: this.state.adjustPIN }))
	}
	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.confirmAdjustPIN();
		}
	}
	base64ToBlob = (base64Data, contentType) => {

		contentType = contentType || '';
		var sliceSize = 1024;
		var byteCharacters = atob(base64Data);
		var bytesLength = byteCharacters.length;
		var slicesCount = Math.ceil(bytesLength / sliceSize);
		var byteArrays = new Array(slicesCount);

		for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
			var begin = sliceIndex * sliceSize;
			var end = Math.min(begin + sliceSize, bytesLength);

			var bytes = new Array(end - begin);
			for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
				bytes[i] = byteCharacters[offset].charCodeAt(0);
			}
			byteArrays[sliceIndex] = new Uint8Array(bytes);
		}
		return new Blob(byteArrays, { type: contentType });
	}

	revertToDashboard(e) {
		window.location.hash = ''
		e.stopPropagation();
	}



	componentWillMount() {
		this.cookies = this.props.cookies;

		if (this.cookies.get('dme') == 'true' && window.location.pathname == '/loginwithmicrosoft') {
			this.cookies.remove('dme')
			console.log('hit 4')
			window.location.pathname = '/dme'
		} else {
			console.log('hit 1')
			if (window.location.pathname == '/dme') {
				console.log('hit 2')
				this.cookies.set('dme', true, { path: '/' })
			}
			console.log('hit 3')
			this.connectWebSocket()


			this.saveCreds = (loginCreds) => {
				//this.setState({ loginCreds: loginCreds })
				//this.cookies.set('loginCreds', loginCreds, { path: '/' })
			}
			if (this.cookies.get('loggedIn') === 'true') {
				this.setState({
					//loggedIn: this.cookies.get('loggedIn') === 'true' ? true : false,
					//loginCreds: this.cookies.get('loginCreds'),
					activeView: '',
				});
			}


			this.pingTimer = 30000
			this.ping = setTimeout(this.checkSocket, this.pingTimer)


		}


	}

	connectWebSocket = () => {
		if (this.ws) {
			this.ws.close()
			delete this.ws
		}
		var protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
		var port = window.location.hostname == 'localhost' ? ':8765' : window.location.port ? ':' + window.location.port : ''

		this.forceUpdate()

		this.ws = new WebSocket(protocol + '//' + window.location.hostname + port);

		this.ws.onopen = () => {
			console.log("HERE 1")
			console.log(this.state)
			if (this.cookies.get('microsoftNonce')) {
				this.ws.send(JSON.stringify({ route: 'completemicrosoftlogin', nonce: this.cookies.get('microsoftNonce') }))
			} else if (this.cookies.get('session')) {
				console.log("There is a session cookie. Passing that back in ")
				this.ws.send(JSON.stringify({ route: 'login', reconnect: true, session: this.cookies.get('session') }))
			}
		};

		this.ws.onmessage = (e) => {
			console.log("HERE 2")
			var data = JSON.parse(e.data);

			if (data.route === "setState") {
				//Set data.state.session to the session cookie
				console.log("Setting Session Cookie")
				console.log(data.state)
				this.cookies.set('session', data.state.session, { path: '/' })


				if (data.state.hasOwnProperty('domain')) {
					window.domain = data.state.domain
				}
				if (data.state.loggedIn && this.cookies.get('impersonating') && this.state.domain != this.cookies.get('impersonating')) {
					data.state.domain = this.cookies.get('impersonating')
					console.log('impersonating')
					console.log("Setting Application State 1")
					console.log(data.state)


					this.setState(data.state, () => {
						this.ws.send(JSON.stringify({ route: 'impersonate', domain: this.cookies.get('impersonating') }))
					})


				} else if (data.state.hasOwnProperty('RealTimeStats')) {
					if (this.state.activeView == 'Realtime%20Statistics') {
						console.log("Setting Application State 2")
						console.log(data.state)
						this.setState(data.state)
					}

				} else if (Object.keys(data.state).length == 1 && data.state.hasOwnProperty('NotificationDashboard')) {
					if (this.state.activeView == 'Notification%20Dashboard') {
						console.log("Setting Application State 3")
						console.log(data.state)
						this.setState(data.state)
					}

				} else {
					console.log("Setting Application State 4")
					console.log(data.state)
					this.setState(data.state)
					for (var stateType in data.state) {
						if (stateType === 'loggedIn') {
							this.cookies.set(stateType, data.state[stateType], { path: '/' })
						} else if (stateType === 'impersonating' && data.state[stateType]) {
							this.cookies.set(stateType, this.state.domain, { path: '/' })
						}
					}
				}
			} else if (data.route === "alterState") {
				console.log("Altering Application State")
				console.log(data.value)
				console.log(data)

				var altState = {}

				if (this.state[data.state]) {
					altState[data.state] = this.state[data.state]
				} else {
					altState[data.state] = {}
				}
				//if path is an array, then we need to loop through the array and set the value at the end of the path
				if (Array.isArray(data.path)) {
					var path = altState[data.state]
					for (var i = 0; i < data.path.length; i++) {
						if (i === data.path.length - 1) {
							path[data.path[i]] = data.value
						} else {
							if (path[data.path[i]]) {
								path = path[data.path[i]]
							} else {

								path[data.path[i]] = {}
								path = path[data.path[i]]
							}
						}
					}
				} else {
					altState[data.state][data.path] = data.value
				}

				this.setState(altState)
			} else if (data.route === "deleteState") {
				console.log("Deleting Application State")
				console.log(data.path)

				var delState = {}
				delState[data.state] = this.state[data.state]
				//if path is an array, then we need to loop through the array and set the value at the end of the path
				if (Array.isArray(data.path)) {
					var path = delState[data.state]
					for (var i = 0; i < data.path.length; i++) {
						if (i === data.path.length - 1) {
							delete path[data.path[i]]
						} else {
							if (path[data.path[i]]) {
								path = path[data.path[i]]
							} else {
								path[data.path[i]] = {}
								path = path[data.path[i]]
							}
						}
					}
				} else {
					delete delState[data.state][data.path]

				}



				this.setState(delState)
			} else if (data.route === "memo") {
				console.log("Alerting with memo")
				console.log(data.content)

				this.setState({ memo: data })
			} else if (data.route === "progress") {
				console.log("Updating Progress")
				console.log(data.content)

				this.setState({ progress: data })
			} else if (data.route === "loginWithMicrosoft") {
				console.log("Logging in with Microsoft")
				console.log(data.nonce)
				this.cookies.set('microsoftNonce', data.nonce, { path: '/' })
				window.location = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=0d803506-1f33-43b9-9149-ac49d3ace923&response_type=id_token&redirect_uri=" + window.location.origin + "/loginwithmicrosoft&response_mode=form_post&scope=openid&state=12345&nonce=" + data.nonce

			} else if (data.route === "download") {
				console.log("Updating Progress")
				console.log(data.file)

				if (window.navigator.msSaveOrOpenBlob) {
					console.log('This is IE!')
					var fileData = this.base64ToBlob(data.file, "application/zip");
					var blobObject = new Blob([fileData]);

					window.navigator.msSaveOrOpenBlob(blobObject, data.filename);

				} else {
					var url = window.URL.createObjectURL(this.base64ToBlob(data.file, "application/zip"));
					var a = document.createElement("a");
					a.style = "display: none";
					a.href = url;
					a.download = data.filename;

					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				}
			}
		};
	}

	checkSocket = () => {
		this.ping = setTimeout(this.checkSocket, this.pingTimer)

		if (this.ws.readyState !== 1) {
			this.forceUpdate();
			console.log(this.ws.readyState)
			this.pingTimer = Math.round(this.pingTimer * 1.25)
			this.connectWebSocket()
		} else {
			this.pingTimer = 1000
		}
	}

	logout = () => {
		this.cookies.remove('microsoftNonce', { path: '/' })
		this.cookies.remove('session', { path: '/' })
		this.cookies.remove('impersonating', { path: '/' })
		this.ws.send(JSON.stringify({ route: 'logOut' }))
	}

	cancel = () => {
		this.setState({ memo: false, adjustingPIN: false, adjustPIN: '', adjustPINError: '', help: false, progress: false })
	}

	revert = (e) => {
		this.cookies.remove('impersonating', { path: '/' })
		this.ws.send(JSON.stringify({ route: 'revert' }))
	}
	impersonate = (e) => {
		console.log('impersonate')
		console.log(e)
		this.cookies.set('impersonating', e, { path: '/' })
		this.ws.send(JSON.stringify({ route: 'impersonate', domain: e }))
	}

	activateView = () => {
		if (window.location.hash.length > 3) {
			this.setState({ activeView: window.location.hash.replace('#', '') })
		} else if (this.state.availableViews.length > 0) {
			window.location.hash = this.state.availableViews[0].title
			this.activateView()
		}
	}

	componentDidMount() {
		window.addEventListener("hashchange", this.activateView, false);
	}


	componentDidUpdate() {
		if (window.location.hash.length < 3 && this.state.views.length > 0) {
			this.activateView()
		}
		if (this.state.loggedIn && !this.state.activeView) {
			this.activateView()
		}
	}
	activate = view => e => {
		window.location.hash = view;
		e.stopPropagation();
	}

	render() {
		var adjustPIN = ""
		if (this.state.adjustingPIN || this.state.passwordExpired) {
			adjustPIN = (
				<div className="blackout">
					<div className="pop" onKeyUp={this.checkEnter}>
						{this.state.passwordExpired ? '' : <div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>}

						<div className="snazzyInputBox">
							<input className="textInput" type="password" required value={this.state.adjustPIN} onChange={this.adjustPINChange} ></input>
							<span className="inputBar"></span><label className="textLabel">Choose Your New Password</label>
						</div>
						<div className="error">{this.state.adjustPINError}</div>
						{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmAdjustPIN}>Change My Password</div>}
					</div>
				</div>
			)
		}
		var helpMenu = ""
		if (this.state.help) {
			helpMenu = (
				<div className="blackout" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
					<div className="pop helpPage" style={{ padding: '30px', backgroundColor: '#fff', borderRadius: '8px', maxWidth: '450px', width: '100%', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', textAlign: 'center' }} onKeyUp={this.checkEnter}>
						<div className="viewCloser" style={{ position: 'absolute', top: '10px', right: '10px', width: '24px', height: '24px', cursor: 'pointer' }} onClick={this.cancel}></div>

						<div className="helpContent">
							<h2 style={{ color: '#333', marginBottom: '20px', fontSize: '22px' }}>Contact Technical Support</h2>
							<p style={{ color: '#555', fontSize: '14px', marginBottom: '20px' }}>We’re here to help 24/7. Reach out through any of the following methods:</p>
							<div className="contactInfo" style={{ textAlign: 'left', fontSize: '14px', color: '#333' }}>
								<div className="contactItem" style={{ marginBottom: '10px' }}>
									<strong>Phone:</strong> <span>(518) 438-6000, option 4</span>
								</div>
								<div className="contactItem" style={{ marginBottom: '10px' }}>
									<strong>Toll Free:</strong> <span>(800) 778-2927, option 4</span>
								</div>
								<div className="contactItem" style={{ marginBottom: '10px' }}>
									<strong>Emergency (After Hours):</strong> <span>(833) 890-0998, stay on the line for an engineer</span>
								</div>
								<div className="contactItem" style={{ marginBottom: '10px' }}>
									<strong>Email:</strong> <a href="mailto:techsupport@dirad.com" style={{ color: '#0073e6', textDecoration: 'none' }}>techsupport@dirad.com</a>
								</div>
								<div className="contactItem" style={{ marginBottom: '10px' }}>
									<strong>Helpdesk:</strong> <a href="https://support.dirad.com" target="_blank" rel="noopener noreferrer" style={{ color: '#0073e6', textDecoration: 'none' }}>support.dirad.com</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
		var memo = ""
		if (this.state.memo) {
			memo = (
				<div className="blackout">
					<div className="pop" onKeyUp={this.checkEnter}>
						<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>

						<div style={{ color: this.state.memo.color, marginBottom: '25px' }} >
							{this.state.memo.content}
						</div>

						{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.cancel}>Okay</div>}
					</div>
				</div>
			)
		}


		var progress = ""
		if (this.state.progress) {
			progress = (
				<div className="blackout">
					<div className="pop" onKeyUp={this.checkEnter} style={{ width: '300px' }}>
						<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>
						<pre ><div style={{ fontFamily: 'Arial' }}>{this.state.progress.content}</div></pre>
						<div style={{ height: '20px', transition: 'width .5s', backgroundColor: this.state.progress.color, width: this.state.progress.perc + '%', margin: '25px 0px' }} ></div>
					</div>
				</div>
			)
		}
		if (window.location.pathname == '/enroll') {
			//return (<Enrollment />);
		} else if (this.state.TwoFactor) {
			//loggedIn: false, loading: false, TwoFactor: true, user: user
			return (<TwoFactor ws={this.ws} loggedIn={this.state.loggedIn} session={this.state.session} loginError={this.state.loginError} />);
		} else if (!this.state.loggedIn) {
			return (<Login saveCreds={this.saveCreds} ws={this.ws} onLoginAttempt={this.loginAttempt} onLogin={this.successfulLogin} loggedIn={this.state.loggedIn} loginError={this.state.loginError} />);
		} else if (window.location.pathname == '/dme') {
			//return (<Dme />);
		} else {
			if (this.state.views && this.state.views.length > 0 && encodeURIComponent(this.state.activeView) !== encodeURIComponent(window.location.hash.replace('#', ''))) {
				console.log(this.state.activeView + decodeURIComponent(window.location.hash.replace('#', '')) + this.state.views[0].title)
				window.location.hash = encodeURIComponent(this.state.views[0].title)
			}

			for (var views = [], i = 0; i < this.state.views.length; i++) {
				for (var viewData = {}, a = 0; a < this.state.views[i].data.length; a++) {
					viewData[this.state.views[i].data[a]] = this.state[this.state.views[i].data[a]];
				}
				viewData[this.state.views[i].view] = this.state[this.state.views[i].view]
				console.log(this.state.views[i].view)
				console.log(i)
				console.log(this.state.views[i])
				var ViewType = Views[this.state.views[i].view].comp
				window[this.state.views[i].view + 'Functions'] = ViewType
				views.push(
					<div key={"view" + i} id={this.state.views[i].view} className={this.state.activeView === encodeURIComponent(this.state.views[i].title) ? 'active view' : 'view'} >
						{/* <div className="viewHeader">
							<h1>{this.state.views[i].title}</h1>
						</div> */}

						<ViewType img={img} view={this.state.views[i].view} ref={(component) => { if (component) { window[component.props.view + 'Functions'] = component } }} features={this.state.features} ws={this.ws} data={viewData} active={this.state.activeView === encodeURIComponent(this.state.views[i].title)} />
					</div>
				)
			}
			var navOptions = []
			for (var option of this.state.availableViews) {
				navOptions.push(<div key={option.title} style={this.state.activeView && (this.state.activeView == encodeURIComponent(option.title) || this.state.activeView == option.title) ? { backgroundColor: '#2A6AA9' } : null} className="menuOption" onClick={this.activate(option.title)}><img src={img[Views[option.view].icon]} alt={option.title + " Icon"} /><div>{option.title}</div></div>)
			}
			return (
				<div style={{ display: "flex" }}>
					<nav
						className={this.state.menu ? "active" : ""}
						style={{ overflowY: "auto", overflowX: "hidden" }}
					>
						<div style={{ position: "absolute", width: "300px" }}>{navOptions}</div>
					</nav>

					<div className="App">
						<div className="floating-header">
							<div className="floating-header-item" onClick={this.revertToDashboard}>
								<img src={img.dirad_logo} alt="Dirad Logo" className="logo" />
							</div>


							<div className="floating-nav">
								<div
									className={`floating-nav-item ${this.state.dropdownDomainVisible ? "active" : ""
										}`}

									onClick={() =>
										(this.state.domains.length > 0) ? this.setState({
											dropdownDomainVisible: !this.state.dropdownDomainVisible,
											dropdownEmailVisible: false, // Close the other dropdown
										})
											: ""
									}
									style={{ position: "relative", zIndex: 1000, minWidth: "180px" }}
									ref={(node) => (this.domainRef = node)}
								>
									<FaBuilding size={15} color="#ecf0f1" />
									<span>{this.state.org}</span>

									<div
										className={`dropdown ${this.state.dropdownDomainVisible ? "visible" : ""
											}`}
										style={{ zIndex: 1001 }}
									>
										<div className="submenu-item" onClick={this.revert}>
											<FaUndo className="submenu-icon" />
											<span className="dropdown-button">Revert</span>
										</div>
										{this.state.domains.map((domain, index) => {
											const displayDomain = domain.length > 8 ? domain.substring(0, 7) + "..." : domain;
											return (
												<div
													key={index}
													className="submenu-item"
													onClick={() => this.impersonate(domain)}
												>
													<FaGlobe className="submenu-icon" />
													<span className="dropdown-button">{displayDomain}</span>
												</div>
											);
										})}
									</div>
								</div>

								<div
									className={`floating-nav-item ${this.state.dropdownEmailVisible ? "active" : ""
										}`}
									onClick={() =>
										this.setState({
											dropdownEmailVisible: !this.state.dropdownEmailVisible,
											dropdownDomainVisible: false, // Close the other dropdown
										})
									}
									style={{ position: "relative", zIndex: 1000, minWidth: "180px" }}
									ref={(node) => (this.emailRef = node)}
								>
									<FaIdBadge size={15} color="#ecf0f1" />
									<span>{this.state.user.email}</span>

									<div
										className={`dropdown ${this.state.dropdownEmailVisible ? "visible" : ""
											}`}
										style={{ zIndex: 1001 }}
									>
										<div className="submenu-item" onClick={this.adjustPIN}>
											<FaTools className="submenu-icon" />
											<span className="dropdown-button">Settings</span>
										</div>
										<div className="submenu-item" onClick={() => this.logout()}>
											<FaSignOutAlt className="submenu-icon" />
											<span className="dropdown-button">Logout</span>
										</div>
										<div className="submenu-item" onClick={() => this.help()}>
											<FaQuestion className="submenu-icon" />
											<span className="dropdown-button">Help</span>
										</div>
									</div>
								</div>
							</div>



						</div>

						<div className="body">
							<div className="viewer activated">{views}</div>
						</div>

						{adjustPIN}
						{helpMenu}
						{memo}
						{progress}

						{/* Inline Styles */}
						<style jsx>{`
							  .floating-header {
							    display: flex;
							    align-items: center;
							    justify-content: space-between;
							    padding: 15px 30px;
							    background-color: transparent;
							    color: #002948;
							  }
													
							  .floating-header-item {
							    color: #002948;
							    padding: 10px 20px;
							    border-radius: 20px;
							    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
							    display: inline-block;
							    cursor: pointer;
							  }
													
							  .floating-header-item .logo {
							    height: 40px;
							    display: block;
							  }
													
							  .floating-nav {
							    display: flex;
							    gap: 20px;
							  }
													
							  .floating-nav-item {
							    background-color: #002948;
							    color: #ecf0f1;
							    padding: 10px 20px;
							    border-radius: 20px;
							    display: flex;
							    align-items: center;
							    gap: 10px;
							    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
							    cursor: pointer;
							    position: relative;
							    transition: transform 0.2s, background-color 0.2s;
							    min-width: 180px;
							  }
													
							  .floating-nav-item.active,
							  .floating-nav-item:hover {
							    background-color: #2a6aa9;
							    transform: translateY(-5px);
							  }
													
							  .floating-nav-item span {
							    margin: 0;
							  }
													
							  .dropdown {
							    position: absolute;
							    top: 50px;
							    left: 15px; /* Adjust to move the dropdown to the right */
							    display: block;
							    visibility: hidden;
							    width: 100%;
							    padding: 10px 0;
							    opacity: 0;
							    transform: translateY(-20px);
							    transition: opacity 0.3s ease, transform 0.3s ease;
							  }
													
							  .dropdown.visible {
							    visibility: visible;
							    opacity: 1;
							    transform: translateY(0);
							  }
													
							  .submenu-item {
							    background-color: #002948;
							    color: #ecf0f1;
							    padding: 6px 8px; /* Reduced padding to make it narrower */
							    border-radius: 15px;
							    margin-bottom: 8px;
							    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
							    cursor: pointer;
							    transition: transform 0.2s, background-color 0.2s;
							    display: flex;
							    align-items: center;
							    justify-content: flex-start;
							    gap: 8px;
							    width: 120px; /* Reduced width to make it smaller */
							  }
													
							  .submenu-item:hover {
							    background-color: #2a6aa9;
							    transform: translateY(-5px);
							  }
													
							  .submenu-icon {
							    width: 16px;
							    height: 16px;
							  }
													
							  .dropdown-button {
							    color: #ecf0f1;
							  }
							`
						}</style>
					</div>
				</div>
			);

		}
	}
}
export default withCookies(App);
